import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import Loading from "../general/Loading.js";
import LocationSelect from "../general/LocationSelect.js";
import Search from "../general/Search.js";
import DateTd from "../table-componets/DateTd.js";
import LinkTd from "../table-componets/LinkTd.js";
import GeneralTd from "../table-componets/GeneralTd.js";
import ButtonTd from "../table-componets/ButtonTd.js";
import AssignedTo from "./AssignedTo";
import { DATE, DATETIME } from "../../utils/dateFormats";

class Issues extends React.Component {
  state = {
    selectedLocationId: "",
    searchText: "",
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "created_at",
    orderDir: "ASC",
    issues: [],
    loading: true,
    isOpen: true,
    urgency: null,
    attachment: null
  };

  componentWillMount() {
    document.title = "Open Issues";
  }

  componentDidMount() {
    this.buildData();
  }

  buildData() {
    var that = this;
    var params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir
    };

    if (this.state.urgency != null && this.state.urgency !== "null") {
      params["urgency"] = this.state.urgency;
    }

    if (this.state.isOpen != null) {
      params["is_open"] = this.state.isOpen;
    }

    if (this.state.attachment != null) {
      params["attachment"] = this.state.attachment;
    }

    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }

    if (this.state.searchText) {
      params["search"] = this.state.searchText;
    }

    if (this.props.isMyIssues) {
      params["my_issues"] = true;
    }

    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/issues.json",
      params: params,
      responseType: "json"
    }).then(function(response) {
      that.setState({ loading: false });
      that.setState({ issues: response.data });
      that.setState({
        totalPages: Math.ceil(response.headers.total / that.state.perPage)
      });
    });
  }

  newLocation(newLocation) {
    this.setState({ selectedLocationId: newLocation });
    this.setState({ page: 1 });
    this.buildData();
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch });
    this.setState({ page: 1 });
    this.buildData();
  }

  sortData(orderBy) {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: "DESC" });
    }

    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  changePage(increment) {
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      50
    );
  }

  openModal() {
    $("#filtersModal").modal("show");
  }

  handleUrgencyChange(event) {
    this.setState({ urgency: event.target.value });
  }

  handleStatusChange(event) {
    if (this.props.isMyIssues) {
      if (event.target.value == "true") {
        var boolean = true;
        document.title = "My Open Issues";
      } else {
        var boolean = false;
        document.title = "My Closed Issues";
      }
    } else {
      if (event.target.value == "true") {
        var boolean = true;
        document.title = "Open Issues";
      } else {
        var boolean = false;
        document.title = "Closed Issues";
      }
    }

    this.setState({ isOpen: boolean });
  }

  handleAttachmentChange(event) {
    if (event.target.value == "true") {
      var boolean = true;
    } else if (event.target.value == "false") {
      var boolean = false;
    } else {
      var boolean = null;
    }

    this.setState({ attachment: boolean });
  }

  viewResults() {
    $("#filtersModal").modal("hide");
    setTimeout(
      function() {
        this.buildData();
      }.bind(this),
      100
    );
  }

  clearFilters() {
    var that = this;

    that.setState({
      isOpen: true,
      urgency: null,
      attachment: null
    });

    this.setState({ isOpen: true });
    this.setState({ urgency: "" });
    this.setState({ attachment: "" });

    $("#filtersModal").modal("hide");

    setTimeout(
      function() {
        that.buildData();
      }.bind(that),
      100
    );
  }

  exportData() {
    var params = {};

    if (this.state.urgency != null) {
      params["urgency"] = this.state.urgency;
    }

    if (this.state.isOpen != null) {
      params["is_open"] = this.state.isOpen;
    }

    if (this.state.selectedLocationId) {
      params["location_id"] = this.state.selectedLocationId;
    }

    axios
      .get("/schedule_issues_export", {
        params: params
      })
      .then(function(response) {
        toastr.info('Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads.');
      })
      .catch(function(error) {
        toastr.error("Unable to export issues at this time");
      });
  }

  renderPagination() {
    return (
      <div>
        <p>
          {"Showing page " + this.state.page + " of " + this.state.totalPages}
        </p>
        {this.state.page == 1 && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page != 1 && (
          <a tabIndex={0}
            className="btn btn-default"
            onClick={() => this.changePage(-1)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.changePage(-1);
              }
            }}
          >
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page < this.state.totalPages && (
          <a  tabIndex={0}
              className="btn btn-default"
              onClick={() => this.changePage(1)}
              onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.changePage(1);
              }
            }}
          >
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
        {this.state.page == this.state.totalPages && (
          <a className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
      </div>
    );
  }

  renderBody() {
    var that = this;
    var issues = [];

    _.forEach(this.state.issues, function(issue, index) {
      switch (issue.urgency) {
        case "Low":
          var urgencyCss = "success";
          break;
        case "Medium":
          var urgencyCss = "warning";
          break;
        case "High":
          var urgencyCss = "danger";
          break;
        default:
          var urgencyCss = "";
      }

      issues.push(
        <tr key={index}>
          <GeneralTd fieldValue={issue.location.name} />
          <GeneralTd fieldValue={issue.problem} />
          <GeneralTd fieldValue={issue.urgency} fieldClassName={urgencyCss} />
          <DateTd fieldValue={issue.due_date} fieldFormat={DATE} />
          <LinkTd
            fieldName={issue.user.last_name + ", " + issue.user.first_name}
            fieldURL={"/users/" + issue.user_id}
          />
          <DateTd fieldValue={issue.created_at} fieldFormat={DATE} />
          <td>
            <AssignedTo isOnlyData={true} users={issue.assigned_users} />
          </td>
          <td>
            {issue.description && (
              <a data-tip={issue.description} className="styled-link">
                <span className="material-icons icon-in-row">description</span>
                <ReactTooltip />
              </a>
            )}

            {issue.attachments_count > 0 && (
              <a
                href={"/issues/" + issue.id}
                className="styled-link pointer-hand"
                target="_blank"
              >
                <span className="material-icons icon-in-row">attachment</span>
              </a>
            )}

            {issue.comment_count > 0 && (
              <a
                href={"/issues/" + issue.id}
                className="styled-link pointer-hand"
                target="_blank"
              >
                <span className="material-icons icon-in-row">comment</span>
              </a>
            )}
          </td>

          <ButtonTd fieldName="VIEW" fieldURL={"/issues/" + issue.id} />
        </tr>
      );
    });

    return <tbody>{issues}</tbody>;
  }

  renderMobileCards() {
    var that = this;
    var issues = [];

    _.forEach(this.state.issues, function(issue, index) {
      issues.push(
        <div key={index} className="well shadowDepth1">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              <span className="pull-right">
                <a
                  href={"/issues/" + issue.id}
                  className="btn btn-text pull-right"
                >
                  VIEW
                </a>
              </span>
            </div>
            <div className="col-xs-12">
              <p>
                {issue.location.name}
                <br />
                <span className="margin-right-five">
                  {moment(issue.created_at).format(DATETIME)} |
                </span>
                <a href={"/users/" + issue.user_id} className="styled-link">
                  {issue.user.last_name + ", " + issue.user.first_name}
                </a>
              </p>
            </div>
          </div>
          <p>
            {issue.problem}

            <div>
              {issue.due_date && (
                <span>
                  <br />
                  Due Date: {moment(issue.due_date).format(DATE)}
                </span>
              )}
            </div>
          </p>
          {issue.attachments_count > 0 && (
            <span className="label label-success margin-right-five">
              {issue.attachments_count}
              {issue.attachments_count == 1 ? " Attachment" : " Attachments"}
            </span>
          )}
          {issue.comment_count > 0 && (
            <span className="label label-default">
              {issue.comment_count}
              {issue.comment_count == 1 ? " Comment" : " Comments"}
            </span>
          )}
        </div>
      );
    });

    return <span>{issues}</span>;
  }

  renderH1() {
    if (this.props.isMyIssues) {
      if (this.state.isOpen) {
        return <h1>My Open Issues</h1>;
      } else {
        return <h1>My Closed Issues</h1>;
      }
    } else {
      if (this.state.isOpen) {
        return <h1>Open Issues</h1>;
      } else {
        return <h1>Closed Issues</h1>;
      }
    }
  }

  render() {
    const { isMyIssues } = this.props;
    var that = this;

    return (
      <div>
        {this.renderH1()}
        <div className="row">
          {isMyIssues ? null : (
            <LocationSelect
              locationId={this.props.locationId}
              locations={this.props.locations}
              selectClassName="col-md-3 col-xs-12"
              newLocationCallback={newLocation => this.newLocation(newLocation)}
            />
          )}
          <Search newSearchCallback={newSearch => this.newSearch(newSearch)} />
          <div className="col-xs-6 col-sm-6 col-md-2">
          <a 
            tabIndex={0}
            className="btn btn-grey btn-raised pull-right"
            onClick={() => this.openModal()}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                this.openModal();
              }
            }}
          >
            FILTERING OPTIONS
          </a>

            <br className="visible-xs visible-sm" />
            <br className="visible-xs visible-sm" />
          </div>
          {isMyIssues ? null : (
            <div className="col-xs-6 col-sm-6 col-md-4 pull-right">
              <div className="pull-right">
                <a
                  className="btn btn-pink btn-raised btn-long margin-right-five"
                  href={
                    "/issues/new?location_id=" + that.state.selectedLocationId
                  }
                >
                  ADD
                </a>
                <a tabIndex={0}
                  className="btn btn-indigo btn-raised btn-long margin-right-five hidden-xs"
                  onClick={() => that.exportData()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.exportData();
                    }
                  }}
                >
                  EXPORT
                </a>
                <br className="visible-xs visible-sm" />
              </div>
            </div>
          )}
        </div>
        <br />
        {this.state.loading || !that.state.issues.length ? (
          <Loading
            loading={this.state.loading}
            noDataMessage={this.props.noRecordsMessage}
          />
        ) : (
          <div>
            <table className="table table-clean table-white hidden-xs">
              <thead>
                <tr>
                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("locations-name"); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Location"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("locations-name");
                        }
                      }}
                    >
                      Location
                    </a>
                  </th>

                  <th width="33%">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("problem"); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Problem"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("problem");
                        }
                      }}
                    >
                      Problem
                    </a>
                  </th>

                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("urgency"); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Urgency"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("urgency");
                        }
                      }}
                    >
                      Urgency
                    </a>
                  </th>

                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("due_date"); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Due Date"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("due_date");
                        }
                      }}
                    >
                      Due Date
                    </a>
                  </th>

                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("users-last_name"); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Submitted By"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("users-last_name");
                        }
                      }}
                    >
                      Submitted By
                    </a>
                  </th>

                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData("created_at"); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Submitted At"
                      tabIndex="0"
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.sortData("created_at");
                        }
                      }}
                    >
                      Submitted At
                    </a>
                  </th>

                  {isMyIssues ? null : <th>Assigned To</th>}
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              {this.renderBody()}
            </table>
            <div className="visible-xs">{this.renderMobileCards()}</div>
            {this.renderPagination()}
          </div>
        )}
        <div id="filtersModal" className="modal fade" role="dialog" tabIndex={0}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button id="modalCloseBtn" tabIndex={0} type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <h4 className="modal-title">Filters</h4>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xs-12">
                    <label>Urgency</label>
                    <select
                      title="Urgency"
                      value={that.state.urgency}
                      onChange={e => that.handleUrgencyChange(e)}
                      className="form-control"
                    >
                      <option value="null">All</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <label>Status</label>
                    <select
                      title="Status"
                      value={that.state.isOpen}
                      onChange={e => that.handleStatusChange(e)}
                      className="form-control"
                    >
                      <option value="true">Open</option>
                      <option value="false">Closed</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <label>Attachment</label>
                    <select
                      title="Attachment"
                      value={that.state.attachment}
                      onChange={e => that.handleAttachmentChange(e)}
                      className="form-control"
                    >
                      <option value="null">All</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <br />
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-indigo"
                  onClick={() => that.viewResults()}
                >
                  VIEW RESULTS
                </button>
                <button
                  type="button"
                  className="btn btn-grey"
                  onClick={() => that.clearFilters()}
                >
                  CLEAR FILTERS
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Issues.propTypes = {
  isMyIssues: PropTypes.bool,
  locations: PropTypes.array,
  noRecordsMessage: PropTypes.string
};

Issues.defaultProps = {
  isMyIssues: false,
  locations: []
};

export default Issues;
